export default "__VITE_ASSET__DZ0aK6gv__"